import Vue from 'vue'
import Router from 'vue-router'
import Pool from './views/Pool/'
import Diary from './views/diary/'
import Trade from './views/tradeDetail/'
import Strategies from './views/strategies/'
import User from './views/user/'
import Tags from './views/tags/'
import Settings from './views/Settings/'
import Landing from './views/Landing.vue'
import Register from './views/Register.vue'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Lost from './views/Lost.vue'
import Confirm from './views/confirm.vue'
import Recovery from './views/Recovery.vue'
import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    routes: [{
            path: '/',
            name: 'Home',
            component: Landing
        },
        {
            path: '/pool/:focus?',
            name: 'Pool',
            component: Pool,
            meta: {
                requiresAuth: true,
                keepAlive: true
            }
        },
        {
            path: '/journal/:name/:date?/:message?',
            name: 'Diary',
            component: Diary,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/trades/:name?/:id?/:message?',
            name: 'Trade',
            component: Trade,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/settings',
            name: 'Settings',
            component: Settings,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
            meta: {
                requiresVisitor: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                requiresVisitor: true
            }
        },
        {
            path: '/strategies/:name?/:id?',
            name: 'strategies',
            component: Strategies,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/tags/:name?/:id?',
            name: 'tags',
            component: Tags,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/user/:name?',
            name: 'user',
            component: User,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/recovery/:token',
            name: 'Recovery',
            component: Recovery,
            props: true,
        },
        {
            path: '/confirmation/:token',
            name: 'confirmation',
            component: Confirm,
            props: true,
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout
        },
        {
            path: '/lost',
            name: 'Lost',
            component: Lost
        }
    ]
})